export default __webpack_public_path__ + "static/media/Dental.655a9448.jpg";